import { ResendReleasePaymentHoldRepoImpl } from "domain/repository/ResendReleasePaymentHold/ResendReleasePaymentHoldRepoImpl";
import { useResendReleasePaymentHoldTracked } from "presentation/store/ResendReleasePaymentHold/ResendReleasePaymentHoldMaintenanceProvider";
import { ResendReleasePaymentHoldVM } from "presentation/viewModel/ResendReleasePaymentHold/ResendReleasePaymentHoldVM";
import { useMemo } from "react";

export const useResendReleasePaymentHoldVM = () => {
    const [, setResendReleasePaymentHoldState] = useResendReleasePaymentHoldTracked();
    const resendReleasePaymentHoldMainVM = useMemo(() =>
        ResendReleasePaymentHoldVM({
            dispatch: [setResendReleasePaymentHoldState],
            repo: ResendReleasePaymentHoldRepoImpl(),
        }), [setResendReleasePaymentHoldState])

    return resendReleasePaymentHoldMainVM
}
